<template>
	<div
		v-once
		class="mx-auto mb-4 mt-8 max-w-sm md:mx-auto md:h-36 lg:ml-0 lg:mr-0 lg:h-28 lg:max-w-lg"
	>
		<div
			:id="id"
			class="carclarity-widget mt-su-three transform"
			data-partner-logo-url="{{runtimeConfig.public.CAR_CLARITY_PARTNER_LOGO_URL}}"
			data-modal-primary-colour-hex-value="F2711C"
			data-widget-type="calculator-cta-launcher"
			data-font-family="futura-pt"
			data-font-family-woff2-url="https://use.typekit.net/af/2cd6bf/00000000000000000001008f/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3"
			data-font-family-woff-ur1="https://use.typekit.net/af/2cd6bf/00000000000000000001008f/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3"
			data-font-family-open-type-url="https://use.typekit.net/af/2cd6bf/00000000000000000001008f/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3"
			data-font-weight="500"
			:data-widget-variant="variant"
			data-disclaimer="Calculations made using this calculator are intended as a guide and are
          for illustrative purposes only, and based on the information you
          provide. Indicative repayments exclude lender fees and charges."
		></div>
	</div>
</template>

<script setup>
import { onMounted } from 'vue'

const runtimeConfig = useRuntimeConfig()

const props = defineProps({
	id: {
		type: String,
		default: 'car_clarity_widget_1',
		required: false,
	},
	variant: {
		type: String,
		default: '1',
		required: false,
	},
})

onMounted(() => {
	if (document.getElementById('carClarityWidget')) {
		return
	}

	const script = document.createElement('script')
	script.id = 'carClarityWidget'
	script.src = runtimeConfig.public.CAR_CLARITY_WIDGET_URL
	document.head.appendChild(script)
	script.addEventListener('load', () => {
		if (window.carClarityInit) {
			window.carClarityInit({
				partnerId: `${runtimeConfig.public.CAR_CLARITY_PARTNER_ID}`,
				partnerName: `${runtimeConfig.public.CAR_CLARITY_PARTNER_NAME}`,
				partnerLogoUrl: `${runtimeConfig.public.CAR_CLARITY_PARTNER_LOGO_URL}`,
				environment: `${runtimeConfig.public.CAR_CLARITY_ENVIRONMENT}`,
				googleTagManagerContainerId: `${runtimeConfig.public.CAR_CLARITY_GTM_KEY}`,
			})
		}
	})
})
</script>
